<script setup lang="ts">
const MESSAGES: Record<number, string> = {
  403: 'Nie masz dostępu do tej strony',
};
</script>

<template>
  <section class="bg-surface-section font-inter flex h-screen items-center justify-center">
    <div class="max-w-screen-xl px-4 py-8 lg:px-6 lg:py-16">
      <div class="mx-auto max-w-screen-sm space-y-6 text-center">
        <h1 class="text-bluegray-900 mb-4 text-3xl font-bold tracking-tight md:text-4xl">
          {{
            MESSAGES[Number($route.params.status)] ||
            'Coś poszło nie tak podczas pobierania danych. Spróbuj ponownie później.'
          }}
        </h1>

        <p class="text-global-textColor mb-4 text-lg font-light">
          Przepraszamy za niedogodności. Proszę przejść do strony głównej.
        </p>

        <RouterLink to="/">
          <PrimeButton rounded> Przejdź do strony głównej </PrimeButton>
        </RouterLink>
      </div>
    </div>
  </section>
</template>
